$(document).ready(function(){

  $(window).on("load" , function(){
    setTimeout(function(){

 let data = loyaltylion.program.loyaltyTiers; 
      data.forEach((element , index)=> {
              let topvalue = "";
              let lowervalue = "";
              if(element.bounds.lower == null){            
                  lowervalue = "";
              }else{
                 if(element.bounds.upper == null ){
                    lowervalue = `${Shopify.formatMoney(element.bounds.lower)}`;
                 }else{
                       lowervalue = Shopify.formatMoney(element.bounds.lower);
                 }                 
              }
        
             if( element.bounds.upper ==  null ){
                topvalue = "";                 
              }else{
                   topvalue = `to ${Shopify.formatMoney(element.bounds.upper)}`;
              }

              let myPriceTop = topvalue.split(".");
              let myPricelow = lowervalue.split(".");
   
              
              $(`.lion-tier-compare__header-cell--tier-${index}`).append(`<span class="block_loyality_custom_price">${myPricelow[0]}${element.bounds.upper == null ?"+":""} ${myPriceTop[0] !== "" ? myPriceTop[0] : ''} Yearly</span>`)
              equl(".block_loyality_custom_price")
      })
      
    },1000)
  })
})